import { Moment } from 'moment';
import React from 'react';

import { DismissAnimation, TransitionGroup } from './dismiss-animation';
import { SectionHeader } from './section-header';
import { TeamCardDueScrollNavigation } from './team-card-due-scroll-navigation';
import { Empty, EmptyToday } from './team-cards-due-empty';
import { getGroups, GroupName } from './team-cards-due-groups';

import styles from './team-cards-due-section.less';

const t = require('views/internal/recup-with-helpers')('home');

/* tslint:disable:no-any */
type DueDateCard = any; // TODO: TMON-817 Only pass ids down instead of models
/* tslint:enable:no-any */

interface TeamCardsDueList {
  listName: string;
  groupName: GroupName;
  dueDateCards: DueDateCard[];
  renderDueDate: (dueDateCard: DueDateCard) => JSX.Element;
  EmptyComponent?: typeof Empty | typeof EmptyToday;
  setGroupRef: (groupName: GroupName, groupRef: HTMLDivElement) => void;
}

const TeamCardsDueList: React.StatelessComponent<TeamCardsDueList> = ({
  dueDateCards,
  groupName,
  listName,
  renderDueDate,
  EmptyComponent,
  setGroupRef,
}) => (
  <div ref={setGroupRef.bind(null, groupName)}>
    <SectionHeader>{listName}</SectionHeader>
    {dueDateCards.length === 0 && EmptyComponent && <EmptyComponent l={t.l} />}
    <TransitionGroup component="ul" className={styles.dueList}>
      {dueDateCards.map((dueDateCard) => (
        <DismissAnimation id={dueDateCard.id} key={dueDateCard.id}>
          <li key={dueDateCard.id} className={styles.dueDateCard}>
            {renderDueDate(dueDateCard)}
          </li>
        </DismissAnimation>
      ))}
    </TransitionGroup>
  </div>
);

interface TeamCardsDueSectionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  dueDateCards: DueDateCard[];
  getDueDateOf: (dueDateCard: DueDateCard) => number;
  renderDueDate: (dueDateCard: DueDateCard) => JSX.Element;
  onClickGroup: React.EventHandler<React.MouseEvent<HTMLElement>>;
  selectedGroup: GroupName;
  setGroupRef: (groupName: GroupName, groupRef: HTMLDivElement) => void;
  StickyBoxWaitForMount: typeof React.Component;
  now: Moment;
}

export const TeamCardsDueSection: React.StatelessComponent<
  TeamCardsDueSectionProps
> = ({
  children,
  dueDateCards,
  renderDueDate,
  getDueDateOf,
  now,
  onClickGroup,
  selectedGroup: selectedGroupProp,
  setGroupRef,
  StickyBoxWaitForMount,
  ...props
}) => {
  const groups = getGroups(dueDateCards, getDueDateOf, now, t.l);

  let selectedGroup = selectedGroupProp;
  if (!groups.some(({ group }) => group === selectedGroupProp)) {
    selectedGroup = groups[0].group;
  }

  return (
    <div className={styles.dueDateSection} {...props}>
      <div className={styles.dueDateLists}>
        {groups.map(({ group, name, cards }) => (
          <TeamCardsDueList
            key={group}
            dueDateCards={cards}
            renderDueDate={renderDueDate}
            listName={name}
            groupName={group}
            setGroupRef={setGroupRef}
            EmptyComponent={group === 'due-today' ? EmptyToday : Empty}
          />
        ))}
      </div>

      <StickyBoxWaitForMount className={styles.scrollNavContainer}>
        <TeamCardDueScrollNavigation
          tabs={groups.map(({ group, name, cards }) => ({
            count: cards.length,
            tabText: name,
            selected: selectedGroup === group,
            onClick: onClickGroup.bind(null, group),
          }))}
        />
      </StickyBoxWaitForMount>
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards-due-section.tsx